import React from 'react';
import { ListLinksStyle, WrapperLinks } from './style';

export default function ListLinks({ title, typeDf, year, link }) {
  return (
    <ListLinksStyle>
      <h3>{title}</h3>
      <div>
        <WrapperLinks>
          <ul>
            <li>
              <a href={link.BP1T} target={link.BP1T !== '' && '_blank'} rel="noreferrer">
                BP1T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.BP2T} target={link.BP2T !== '' && '_blank'} rel="noreferrer">
                BP2T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.BP3T} target={link.BP3T !== '' && '_blank'} rel="noreferrer">
                BP3T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.BP4T} target={link.BP4T !== '' && '_blank'} rel="noreferrer">
                BP4T{year}
                {typeDf}
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a href={link.DFC1T} target={link.DFC1T !== '' && '_blank'} rel="noreferrer">
                DFC1T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DFC2T} target={link.DFC2T !== '' && '_blank'} rel="noreferrer">
                DFC2T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DFC3T} target={link.DFC3T !== '' && '_blank'} rel="noreferrer">
                DFC3T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DFC4T} target={link.DFC4T !== '' && '_blank'} rel="noreferrer">
                DFC4T{year}
                {typeDf}
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a href={link.DVA1T} target={link.DVA1T !== '' && '_blank'} rel="noreferrer">
                DVA1T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DVA2T} target={link.DVA2T !== '' && '_blank'} rel="noreferrer">
                DVA2T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DVA3T} target={link.DVA3T !== '' && '_blank'} rel="noreferrer">
                DVA3T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DVA4T} target={link.DVA4T !== '' && '_blank'} rel="noreferrer">
                DVA4T{year}
                {typeDf}
              </a>
            </li>
          </ul>
          <ul></ul>
        </WrapperLinks>
        <WrapperLinks>
          <ul>
            <li>
              <a href={link.DRE1T} target={link.DRE1T !== '' && '_blank'} rel="noreferrer">
                DRE1T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DRE2T} target={link.DRE2T !== '' && '_blank'} rel="noreferrer">
                DRE2T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DRE3T} target={link.DRE3T !== '' && '_blank'} rel="noreferrer">
                DRE3T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DRE4T} target={link.DRE4T !== '' && '_blank'} rel="noreferrer">
                DRE4T{year}
                {typeDf}
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a href={link.DMPL1T} target={link.DMPL1T !== '' && '_blank'} rel="noreferrer">
                DMPL1T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DMPL2T} target={link.DMPL2T !== '' && '_blank'} rel="noreferrer">
                DMPL2T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DMPL3T} target={link.DMPL3T !== '' && '_blank'} rel="noreferrer">
                DMPL3T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.DMPL4T} target={link.DMPL4T !== '' && '_blank'} rel="noreferrer">
                DMPL4T{year}
                {typeDf}
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a href={link.NE1T} target={link.NE1T !== '' && '_blank'} rel="noreferrer">
                NE1T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.NE2T} target={link.NE2T !== '' && '_blank'} rel="noreferrer">
                NE2T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.NE3T} target={link.NE3T !== '' && '_blank'} rel="noreferrer">
                NE3T{year}
                {typeDf}
              </a>
            </li>
            <li>
              <a href={link.NE4T} target={link.NE4T !== '' && '_blank'} rel="noreferrer">
                NE4T{year}
                {typeDf}
              </a>
            </li>
          </ul>
        </WrapperLinks>
      </div>
    </ListLinksStyle>
  );
}
